import React, { useContext, useState, useEffect } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import Copy from '../Common/Copy';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Pagination from '../Common/Pagination';


export default function Top1000() {
  const { togel, formatAddress, setTogel, isSidebarEnabled, setIsSidebarEnabled, formatDateTime } = useContext(GMCContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // Fetch data function
  const getData = async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://futureadmin.gtbspeer.com/api/leaderboard/level");
      const top1000 = res.data?.top_101_1000 || [];
      setData(top1000);
      setLoading(false);
      // console.log('res.data.data', res.data)
      if (res.data.error) return;
      // setData(res.data.data);
      setPages(Math.ceil(top1000.length / pageSize));
    } catch (err) {
      console.log("Error : ", err);
      setLoading(false);
    }
  };

  // Effect to fetch data when the filter or page changes
  useEffect(() => {
    getData();
  }, []); // fetch only once

  return (
    <>
      <Header />
      <Sidebar />
      <div id="layout-wrapper">
        <div className="vertical-overlay" onClick={() => setIsSidebarEnabled((prev) => !prev)} />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* Page Title Section */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                      <li className="breadcrumb-item active">Top 1000 User</li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* Member Report Table Section */}
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Top 1000 User</h4>
                    </div>
                    <div className="card-body">
                      <div className="listjs-table" id="customerList">

                        {/* Table */}
                        <div className="table-responsive table-card mt-3 mb-1 position-relative">

                          {/* 🔄 Overlay Loader */}
                          {loading && (
                            <div
                              className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
                              style={{
                                background: "rgba(255, 255, 255, 0.75)",
                                zIndex: 10,
                                backdropFilter: "blur(3px)",
                              }}
                            ><br />
                              <div class="d-flex justify-content-around my-4">
                                <div class="spinner-border text-primary" role="status"></div>

                              </div>
                              <h6
                                className="text-primary fw-semibold text-center"
                                style={{ fontSize: "0.95rem" }}
                              >
                                Please wait...
                              </h6>
                            </div>
                          )}

                          {/* 🧾 Table (faded while loading) */}
                          <table
                            className="table align-middle table-striped table-bordered mb-0 text-nowrap"
                            id="customerTable"
                            style={{
                              opacity: loading ? 0.5 : 1,
                              transition: "opacity 0.3s ease",
                              fontSize: "0.9rem",
                            }}
                          >
                            <thead className="table-light">
                              <tr>
                                <th className="gridjs-th text-center">#</th>
                                <th className="gridjs-th text-center">Telegram ID</th>
                                <th className="gridjs-th text-center">Username</th>
                                <th className="gridjs-th text-center">Joining Date</th>
                              </tr>
                            </thead>

                            <tbody>
                              {!loading && data.length === 0 ? (
                                <tr>
                                  <td colSpan="4" className="gridjs-td text-center py-4 text-muted fs-6">
                                    No data found
                                  </td>
                                </tr>
                              ) : (
                                data
                                  .slice((currentPage - 1) * pageSize, currentPage * pageSize)
                                  .map((ele, i) => {
                                    const index = (currentPage - 1) * pageSize + (i + 1);
                                    return (
                                      <tr key={i}>
                                        <td className="gridjs-td text-center">{index}</td>
                                        <td className="gridjs-td text-center text-break">
                                          {ele.telegram_id || "-"} <Copy data={ele.telegram_id} />
                                        </td>
                                        <td className="gridjs-td text-center text-break">
                                          <a
                                            target="_blank"
                                            rel="noreferrer"
                                            href={`${process.env.REACT_APP_EXPLORER}/address/${ele.username}`}
                                            className="text-primary text-decoration-none"
                                          >
                                            {ele.username}
                                          </a>
                                          <Copy data={ele.username} />
                                        </td>
                                        <td className="gridjs-td text-center">{formatDateTime(ele.created_at)}</td>
                                      </tr>
                                    );
                                  })
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pages={pages}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}